import { render, staticRenderFns } from "./module3.vue?vue&type=template&id=a4e15b1c&scoped=true"
import script from "./module3.vue?vue&type=script&lang=js"
export * from "./module3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e15b1c",
  null
  
)

export default component.exports